
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { GoogleCalendarService } from "@/services";

export default Vue.extend({
	data() {
		return {
			GoogleCalendarService
		};
	},
	computed: {
		menuItems():ISelectItem<string>[] {
			let result = [] as ISelectItem<string>[];
			result.push({
				text: this.$ct("new-calendar"),
				value: "newCalendar"
			});
			if (this.googleLoggedIn) {
				result.push({
						text: this.$ct("new-google-calendar"),
						value: "newGoogleCalendar"
					},
					{
						text: this.$ct("google-logout"),
						value: "googleLogout"
					});
			} else {
				result.push({
					text: this.$ct("google-login"),
					value: "googleLogin"
				});
			}

			return result;
		},
		googleLoggedIn():boolean {
			return this.GoogleCalendarService.isLoggedIn();
		}
	},
	methods: {
		onEvent(event:string) {
			(this as any)[event]();
		},
		async googleLogin() {
			console.log("Google login triggered");
			await GoogleCalendarService.login();
			this.$emit("refresh");
		},
		googleLogout() {
			GoogleCalendarService.logout();
			this.$emit("refresh");
		},
		newGoogleCalendar() {
			this.$emit("new-google-calendar");
		},
		newCalendar() {
			this.$emit("new-calendar");
		}
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
